import { render, staticRenderFns } from "./storeList.vue?vue&type=template&id=df63197a&scoped=true"
import script from "./storeList.vue?vue&type=script&lang=ts"
export * from "./storeList.vue?vue&type=script&lang=ts"
import style0 from "./storeList.vue?vue&type=style&index=0&id=df63197a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df63197a",
  null
  
)

export default component.exports